var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAutocompleteIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 9,
    height: 5,
    viewBox: "0 0 9 5",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.85755 4.79076L8.55635 1.11195C8.61771 1.05153 8.66642 0.979645 8.69965 0.900441C8.73289 0.821237 8.75 0.736283 8.75 0.65048C8.75 0.564677 8.73289 0.479723 8.69965 0.400518C8.66642 0.321314 8.61771 0.249428 8.55635 0.189005C8.4337 0.0679483 8.26777 -2.10788e-08 8.09482 -2.86388e-08C7.92187 -3.61987e-08 7.75595 0.0679483 7.63329 0.189005L4.36001 3.40633L1.11946 0.189005C0.996805 0.067948 0.830881 -3.46156e-07 0.65793 -3.53716e-07C0.48498 -3.61276e-07 0.319056 0.0679479 0.196398 0.189004C0.134541 0.249201 0.08533 0.320986 0.0516176 0.400201C0.0179052 0.479415 0.000361418 0.564484 1.87892e-06 0.650479C0.00036141 0.736474 0.0179052 0.821544 0.0516176 0.900758C0.08533 0.979973 0.134541 1.05176 0.196398 1.11195L3.8952 4.79076C3.95651 4.85673 4.03091 4.90938 4.11372 4.9454C4.19654 4.98141 4.28597 5 4.37638 5C4.46678 5 4.55621 4.98141 4.63903 4.9454C4.72184 4.90938 4.79624 4.85673 4.85755 4.79076Z",
    fill: "#919191"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAutocompleteIcon);
export default __webpack_public_path__ + "static/media/autocomplete-icon.b3f5c0e1.svg";
export { ForwardRef as ReactComponent };